import tree from 'state';
import { reduce, get, isEmpty, isNumber } from 'lodash';

function insertAssets(content) {
  return reduce(
    content.blocks,
    (accum, data) => {
      if (get(data, 'data.productType') === 'product') {
        accum.products.push(Number(data.data.productMap));
      } else if (get(data, 'data.productType') === 'listing') {
        accum.listings.push(Number(data.data.productMap));
      }
      return accum;
    },
    { listings: [], products: [] }
  );
}

export default function formatData({ content, metadata, tags, category }) {
  const userId = tree.get(['authentication', 'session', 'user_id']);
  const data = {
    content,
    tags,
    category,
  };
  if (metadata) {
    data.preview = metadata.preview || {
      image: metadata.image,
      title: metadata.title,
      description: metadata.description,
    };
    if (!metadata.preview?.image && metadata.image) {
      data.preview.image = metadata.image;
    }
    data.slug = metadata.slug;
    data.writer =
      get(metadata.writer, 'pk') ||
      get(metadata.writer, 'value') ||
      metadata.writer ||
      userId;
    data.company =
      get(metadata.company, 'pk') ||
      get(metadata.company, 'value') ||
      metadata.company ||
      userId;
    if (isNumber(metadata?.co_writer) || metadata.co_writer.pk) {
      data.co_writer =
        get(metadata?.co_writer, 'pk') ||
        get(metadata?.co_writer, 'value') ||
        metadata?.co_writer;
    }
    if (isNumber(metadata?.co_company) || metadata.co_company.pk) {
      data.co_company =
        get(metadata?.co_company, 'pk') ||
        get(metadata?.co_company, 'value') ||
        metadata?.co_company;
    }
    if (!isEmpty(metadata.button_name) && !isEmpty(metadata.button_url)) {
      data.button_name = metadata.button_name;
      data.button_url = metadata.button_url;
    }
  }
  const finalData = { ...data, ...insertAssets(content) };
  return finalData;
}
